import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const assetsSchemaConfigurationRoute: InvariantJiraRoute = {
	name: 'assets-schema-configuration',
	path: '/jira/assets/configure/object-schema/:objectSchemaId',
};
